import { useLogListQuery } from '@generated/graphql';
import { Stack } from '@mui/system';
import { PageTitle } from 'components/common';
import TableLayout from 'layout/TableLayout';
import { DEFAULT_LIMIT } from 'layout/TableLayout/components/TablePagination';
import { LogListData } from './types';
import LOG_LIST_TABLE from './config/columns';
import LOG_LIST_FILTERS from './config/filters';

const LogsList = () => {
  const { data, loading, refetch } = useLogListQuery({
    variables: {
      events: [],
      limit: DEFAULT_LIMIT,
      page: 0,
    },
  });

  const logList = data?.logList?.data || [];
  const totalCount = data?.logList?.totalCount || 0;

  return (
    <Stack spacing={2.5}>
      <PageTitle title='Список логов' />
      <TableLayout<LogListData>
        columns={LOG_LIST_TABLE}
        filters={LOG_LIST_FILTERS}
        data={logList}
        loading={loading}
        emptyPlaceholderText='Пока нет логов'
        totalCount={totalCount}
        rowsPerPageText='Логов на странице'
        refetch={refetch}
      />
    </Stack>
  );
};

export default LogsList;
